var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DgInput',{attrs:{"type":"email","name":_vm.name,"label":_vm.label,"value":_vm.value,"required":_vm.required,"placeholder":_vm.placeholder,"errorMessage":_vm.errorMessage,"initialValue":_vm.initialValue,"validator":_vm.validator},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }